import { useTranslation } from 'react-i18next';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import { trackEvent } from '../lib/analytics';

export default function ContactPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-bg">
        <div className="mx-auto max-w-3xl px-5 py-14">
          <h1 className="text-[28px] font-bold tracking-tight">{t('contactPage.title')}</h1>
          <p className="mt-3 text-[15px] text-ink-soft">{t('contactPage.subtitle')}</p>

          <div className="mt-8 rounded-xl border border-border bg-surface p-6 space-y-4">
            <div className="flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-soft text-primary">
                <i className="ri-mail-line text-[18px]" />
              </div>
              <div>
                <div className="text-[14px] font-semibold text-ink">{t('contactPage.email')}</div>
                <a href="mailto:support@csdmsolutions.com" onClick={() => trackEvent('contact_click', { method: 'email' })} className="text-[14px] text-primary hover:underline">support@csdmsolutions.com</a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-soft text-primary">
                <i className="ri-phone-line text-[18px]" />
              </div>
              <div>
                <div className="text-[14px] font-semibold text-ink">{t('contactPage.phone')}</div>
                <a href="tel:+18483603259" onClick={() => trackEvent('contact_click', { method: 'phone' })} className="text-[14px] text-primary hover:underline">+1 (848) 360-3259</a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-soft text-primary">
                <i className="ri-map-pin-line text-[18px]" />
              </div>
              <div>
                <div className="text-[14px] font-semibold text-ink">{t('contactPage.address')}</div>
                <p className="text-[14px] text-ink-soft">LeadPixel Labs LLC<br/>30 North Gould Street, Ste R<br/>Sheridan, WY 82801, US</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-soft text-primary">
                <i className="ri-time-line text-[18px]" />
              </div>
              <div>
                <div className="text-[14px] font-semibold text-ink">{t('contactPage.responseTime')}</div>
                <p className="text-[14px] text-ink-soft">{t('contactPage.responseTimeText')}</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}